import * as tslib_1 from "tslib";
import * as React from 'react';
import { blueGrey400 } from 'material-ui/styles/colors';
var styles = {
    item: {
        margin: '.2rem 0',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        backgroundColor: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
    },
    badge: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        width: '2rem',
        color: '#fff'
    },
    title: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '.5rem',
        textAlign: 'left',
        display: 'flex',
        justifyContent: 'space-between'
    },
    user: {
        fontWeight: 'bold',
    },
    description: {
        opacity: .54,
    }
};
export default function DayOffCalendarItem(_a) {
    var item = _a.item;
    var backgroundColor = item.color || blueGrey400;
    var badgeStyle = tslib_1.__assign({}, styles.badge, { backgroundColor: backgroundColor });
    return (React.createElement("div", { style: styles.item },
        React.createElement("div", { style: tslib_1.__assign({}, badgeStyle, { gridRow: 1, gridColumn: 1 }) }, item.description.substring(0, 2)),
        React.createElement("div", { style: tslib_1.__assign({}, styles.title, { gridRow: 1, gridColumn: 2 }) },
            React.createElement("small", { style: styles.user }, item.user),
            React.createElement("small", { style: styles.description }, item.description))));
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/dayoffs/DayOffsCalendarItem.tsx
// module id = 792
// module chunks = 0